import React, { Fragment, useEffect, useState } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import { getFormValues, Field } from 'redux-form';

import { 
    List, 
    TextField, 
    StatusField,
    AddButton,
    Drawer,
    Row,
    TextInput,
    SelectInput,
    Modal
} from '../_Components';
import {GET_LIST,CREATE, provider, history } from '../_utils';

import Filter from './Filter';
import Show from './Show';
// import Create from './Create'
import Edit from './Edit'

const statuses = [
    {id: 'Active', name: 'Активен'},
    {id: 'Disabled', name: 'Заблокирован'},
]


const UserForm = ({roles}) => (
    <Fragment>  
        <p>Даннные пользователя</p>
        <Row>
            <Field
                name="last_name"
                label={`Фамилия`}
                component={TextInput}
            />
            <Field
                name="first_name"
                label={`Имя`}
                component={TextInput}
            />
            
        </Row>
        <Row>
            <Field
                name="email"
                label={`E-mail`}
                component={TextInput}
            />
            <Field
                name="role"
                label={`Роль`}
                options={roles}
                component={SelectInput}
            />
        </Row>
    </Fragment>
);


const UsersList = ({formValues}) => {
    const [isMounted, setIsMounted] = useState(false);
    const [roles, setRoles] = useState([]);

    const [openCreate, setOpenCreate] = useState(false);  
    const onCreate = async () => {
        setOpenCreate(true);
    }


    const handleCloseCreate = () => {
        setOpenCreate(false);
    }

    const handleSave = (formValues) => {
        provider( CREATE, '/users', { data: {status: "Active", ...formValues} })
            .then(({ data }) => {
                setOpenCreate(false);
            });
    }
    
    useEffect(() => {
        const getRoles = async () => {
            const { data, status } = await provider(
                GET_LIST,
                '/roles',
                {
                    filter: {},
                    sort: { field: 'name', order: 'ASC' },
                    pagination: { page: 1, perPage: 10000 },
                }
            );
            if(status===200 ){
                setRoles( data.map( d => {return { id: d.id, name: d.label }}));
                setIsMounted(true);
            }
        }
        if(!isMounted){
            getRoles();
        }
    }, [isMounted])

    const handleClose = () => {
        history.push('/users')
    }

    return (
        <Fragment>
            <Route path="/users/:id/:action">
                {({ match }) => {
                    const isMatch = !!(
                        match &&
                        match.params
                    );
                    return (
                        <Fragment>
                            <List
                                refresh={true}
                                creat={false}
                                show={true}
                                actions={
                                    <AddButton handleAddClick={onCreate}/>  
                                }
                                basePath='users'
                                pathToShow={`/show`}
                                filters={<Filter roles={roles} />}
                                filterDefaultValues={formValues}
                                match={match}
                                // filterDefaultValues={filter}
                                perPage={25} 
                                sort={{ field: 'updateAt', order: 'DESC' }} 
                            >
                                <TextField
                                    notSort={true}
                                    source="fullname"
                                    label="Имя"
                                />
                                <TextField
                                    notSort={true}
                                    source="email"
                                    label="E-mail"
                                />
                                <TextField
                                    notSort={true}
                                    source="role"
                                    label="Роль"
                                />
                                <StatusField
                                    notSort={true}
                                    source="status"
                                    label="Статус"
                                />
                            </List>
                            {(isMatch&&match.params.action === 'show') ? (
                                <Drawer
                                    isMatch={isMatch}
                                    handleClose={handleClose}
                                    content={isMatch ?  <Show id={match.params.id} roles={roles} statuses={statuses}/> : null}
                                />
                                
                            ) : null}
                            {(isMatch&&match.params.action === 'edit') ? (
                                <div style={{padding: 0}}>
                                    <Drawer
                                        isMatch={isMatch}
                                        handleClose={handleClose}
                                        content={isMatch ? <Edit id={match.params.id} roles={roles}/> : null}
                                    />
                                    
                                </div>
                            ) : null}
                        </Fragment>
                    );
                
                }}
            </Route>
            {openCreate && (
                <Modal 
                    // width="md"
                    open={openCreate}
                    title="Создание пользователя"
                    handleSaveClick={handleSave} 
                    handleCloseClick={handleCloseCreate} 
                    fields={<UserForm roles={roles}/>}
                />
            )}
        </Fragment>
    );
}


const mapStateToProps = (state, props) => {
    console.log(state);
    var recordLiveValues = getFormValues('userForm')(state);
    let pairs = history.location.search.substring(1).split("&");
    let search = null;
    for ( let i in pairs ) {
        if ( pairs[i] === "" ) continue;
        if(!search) search = {};
        const pair = pairs[i].split("=");
        search[ decodeURIComponent( pair[0] ) ] = decodeURIComponent( pair[1] );
    }
    let searchValues = null;
    for(let key in search){
        if(["orderBy", "order", "page", "rowsPerPage"].indexOf(key)<0){
            if(!searchValues) searchValues = {};
            searchValues[key] = search[key];
        }
    }
    return {
        perPage: search ? +search.rowsPerPage || 25 : 25,
        page: search ? +search.page || 0 : 0,
        formValues: recordLiveValues || { status: 'Active' },
    };
};


export default compose(
    connect(mapStateToProps),
)(UsersList);